export enum SurveyInfoType {
    SELF = 'SELF',
    RETURNING_USER = 'CURR',
}
